/**
 * 工具类
 */

export const dateFormat = (dateObj, format) => {
  let date = {
    "M+": dateObj.getMonth() + 1,
    "d+": dateObj.getDate(),
    "h+": dateObj.getHours(),
    "m+": dateObj.getMinutes(),
    "s+": dateObj.getSeconds(),
    "q+": Math.floor((dateObj.getMonth() + 3) / 3),
    "S+": dateObj.getMilliseconds(),
  };
  if (/(y+)/i.test(format)) {
    format = format.replace(
      RegExp.$1,
      (dateObj.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in date) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1
          ? date[k]
          : ("00" + date[k]).substr(("" + date[k]).length)
      );
    }
  }
  return format;
};

// 日期比较大小
export const compareTime = (time1, time2) => {
  time2 = time2 ? new Date(time2.split("-").join("/")) : new Date();
  // 替换字符，变成标准格式
  time1 = time1 ? new Date(time1.split("-").join("/")) : 0;
  if (time2 < time1) {
    return true;
  } else {
    return false;
  }
};

export const getNewTime = (num) => {
  var date = new Date(); //获取当前时间
  var min = date.getMinutes(); //获取当前分钟
  date.setMinutes(min + num); //3. 设置当前时间+num分钟：把当前分钟数+num后的值重新设置为date对象的分钟数
  var y = date.getFullYear();
  var m = date.getMonth();
  m = m + 1 < 10 ? "0" + (m + 1) : m + 1;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var f = date.getMinutes();
  f = f < 10 ? "0" + f : f;
  var s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  var formatdate = y + "/" + m + "/" + d + " " + h + ":" + f + ":" + s;
  return formatdate;
};

// 直播倒计时
let _timer = null;
// export const getCountdown = (fn, e, t) => {
//   if (!e) throw new Error("请传入结束时间");
//   var _time = t ? t : 1000;
//   _timer = setInterval(() => {
//     var NowTime = new Date(),
//       t = e - NowTime.getTime(),
//       d = Math.floor(t / 1000 / 60 / 60 / 24),
//       h = Math.floor((t / 1000 / 60 / 60) % 24),
//       m = Math.floor((t / 1000 / 60) % 60),
//       s = Math.floor((t / 1000) % 60),
//       result =
//         d +
//         `<span>天</span>` +
//         h +
//         `<span>时</span>` +
//         m +
//         `<span>分</span>` +
//         s +
//         `<span class="s">秒</span>`;
//     if ((d == 0 && h == 0 && m == 0 && s == 0) || d < 0) {
//       clearCountdown();
//     }
//     if ((d == 0 && h == 0 && m == 0 && s == 0) || d < 0) fn(null);
//     if (fn && d >= 0) fn(result);
//   }, _time);
// };
export const getCountdown = (fn, e, t) => {
  if (!e) throw new Error("请传入结束时间");
  let _time = t ? t : 1000;

  const calculateCountdown = () => {
    let NowTime = new Date();
    let times = e - NowTime.getTime();
    let result = "";
    if (times > 0) {
      clearTimeout(_timer);
      let d = Math.floor(times / 1000 / 60 / 60 / 24),
        h = Math.floor((times / 1000 / 60 / 60) % 24),
        m = Math.floor((times / 1000 / 60) % 60),
        s = Math.floor((times / 1000) % 60);
      result =
        d +
        `<span>天</span>` +
        h +
        `<span>时</span>` +
        m +
        `<span>分</span>` +
        s +
        `<span class="s">秒</span>`;
      fn(result); // 返回结果字段
      _timer = setTimeout(calculateCountdown, _time); // 继续下一次计时
    } else {
      fn(false); // 返回 false
      clearTimeout(_timer);
      _timer = null;
    }
  };
  calculateCountdown();
};

// 考试倒计时
let _timer2 = null;
export const getCountdown2 = (fn, e, t) => {
  if (!e) throw new Error("请传入结束时间");
  var _time = t ? t : 1000;
  if (_timer2) {
    clearCountdown2();
  }
  _timer2 = setInterval(() => {
    var NowTime = new Date(),
      t = e - NowTime.getTime(),
      h = Math.floor((t / 1000 / 60 / 60) % 24),
      m = Math.floor((t / 1000 / 60) % 60),
      s = Math.floor((t / 1000) % 60),
      result =
        (h < 10 ? "0" + h : h) +
        `:` +
        (m < 10 ? "0" + m : m) +
        `:` +
        (s < 10 ? "0" + s : s);
    if (h == 0 && m == 0 && s == 0) {
      fn("");
      clearCountdown2();
    }
    if (h == 0 && m == 0 && s == 0) fn(null);
    if (fn && h >= 0) fn(result);
  }, _time);
};

export const clearCountdown = () => {
  clearInterval(_timer);
  _timer = null;
};

export const clearCountdown2 = () => {
  clearInterval(_timer2);
  _timer2 = null;
};

// 将字符串日期转换成秒
export const timeToSecond = (e) => {
  var time = e;
  var len = time.split(":");
  if (len.length == 3) {
    let hour = time.split(":")[0];
    let min = time.split(":")[1];
    let sec = time.split(":")[2];
    return Number(hour * 3600) + Number(min * 60) + Number(sec);
  }
  if (len.length == 2) {
    let min = time.split(":")[0];
    let sec = time.split(":")[1];
    return Number(min * 60) + Number(sec);
  }
  if (len.length == 1) {
    let sec = time.split(":")[0];
    return Number(sec);
  }
};

// 将秒转化为时分秒

export const formatSeconds = (value) => {
  let secondTime = parseInt(value);
  let minuteTime = 0;
  let hourTime = 0;
  if (secondTime >= 60) {
    minuteTime = parseInt(secondTime / 60);
    secondTime = parseInt(secondTime % 60);
  }
  if (minuteTime >= 60) {
    hourTime = parseInt(minuteTime / 60);
    minuteTime = parseInt(minuteTime % 60);
  }
  secondTime = secondTime < 10 ? "0" + secondTime : secondTime;
  minuteTime = minuteTime < 10 ? "0" + minuteTime : minuteTime;
  hourTime = hourTime < 10 ? "0" + hourTime : hourTime;
  if (hourTime === "00") {
    return `${minuteTime}:${secondTime}`;
  } else {
    return `${hourTime}:${minuteTime}:${secondTime}`;
  }
};

// 将时间格式转换成年月日
export function formatTimeToDate(dateTimeString) {
  if (!dateTimeString) return "";
  // 将时间字符串转换为Date对象
  dateTimeString = dateTimeString.replace(/-/g, "/");
  const date = new Date(dateTimeString);

  // 获取年、月、日
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 月份从0开始，所以要加1
  const day = date.getDate();

  // 格式化为'YYYY年M月D日'
  const formattedDate = year + "年" + month + "月" + day + "日";

  return formattedDate;
}

// 今天是周几
export const getWeekDay = (dateTime) => {
  const weekDay = [
    "星期天",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六",
  ];
  const today = new Date(dateTime).getDay();
  return weekDay[today];
};
